export const dispatchLabels = {
  unassigned: 'Рассылка остановлена', broadcasting: 'Сбор откликов',
  awaiting_confirmation: 'Ждём подтверждения обмерщика', assigned: 'Обмерщик назначен',
  reassign_needed: 'Нужно перераспределить',
};
export const responseLabels = {
  pending: 'Ждёт решения', accepted_by_manager: 'Выбран', confirmed: 'Подтверждён',
  declined: 'Отказался / истёк срок', withdrawn: 'Отозван / неактуален',
};
export function arrivalError(dispatch, day, time) {
  if (!(dispatch?.offered_dates || []).includes(day)) return 'Выберите предложенную дату';
  if (!/^\d{2}:\d{2}$/.test(time)) return 'Укажите точное время прибытия';
  const [hours, minutes] = time.split(':').map(Number);
  if (hours > 23 || minutes > 59) return 'Некорректное время';
  const from = dispatch?.offered_time_from?.slice(0, 5);
  const to = dispatch?.offered_time_to?.slice(0, 5);
  if (!from || !to || time < from || time > to) return 'Время должно быть внутри предложенного окна';
  return '';
}
export function isOwnSurvey(event, account) {
  const owner = typeof event?.employee === 'object' ? event.employee?.id : event?.employee;
  return owner != null && account?.id != null && String(owner) === String(account.id);
}
export function canWorkSurvey(event, account) {
  return isOwnSurvey(event, account) && !event?.is_completed
    && ['measuring_premises', 'additional_measuring'].includes(event?.state);
}
export function responseArrival(response) {
  if (!response?.arrival_time) return 'Старый интервал — требуется новый отклик с точным временем';
  return `${response.chosen_date?.split('-').reverse().join('.')} в ${response.arrival_time.slice(0, 5)}`;
}
export function dispatchError(value) {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(dispatchError).join('; ');
  if (value && typeof value === 'object') return Object.values(value).map(dispatchError).filter(Boolean).join('; ');
  return '';
}

export function formatDispatchInstant(value, zone) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Дата не указана';
  try { return date.toLocaleString('ru-RU', { timeZone: zone || 'UTC' }); }
  catch (_) { return `${date.toISOString()} (UTC)`; }
}
export function arrivalReady(event) {
  return event?.arrival ? Boolean(event.arrival.ready) : Boolean(event?.arrived_at);
}
export function canCompleteSurvey(event, account) {
  return canWorkSurvey(event, account) && arrivalReady(event);
}